/* eslint-disable import/prefer-default-export */
import { toValue } from '@vueuse/core';
import { useGiftBasic } from './useGiftBasic';
import { useGiftConsolidated } from './useGiftConsolidated';
import { GIFT_CARD_TYPE as GCT } from '../constants/giftcard';

/**
 *
 * @param {import('@vueuse/core').MaybeRefOrGetter<GCT>} giftCardType
 */
export const useGift = (giftCardType = GCT.BASIC) => (toValue(giftCardType) === GCT.CONSOLIDATED_MASTER ? useGiftConsolidated() : useGiftBasic());
